import { FieldsTypeEnum } from '../enums/fields-type.enum';
import { CodificationFieldMetadataInterface } from '../interfaces/codification-field-metadata.interface';
import { DocsCodificationFieldsInterface } from '../interfaces/docs-codification-fields.interface';

export class DocsCodificationFields implements DocsCodificationFieldsInterface {
  /**
   *
   */
  id?: number;

  /**
   *
   */
  name: string;

  /**
   *
   */
  type: FieldsTypeEnum;

  /**
   *
   */
  typeMetadatas: CodificationFieldMetadataInterface;

  /**
   *
   */
  codificationId?: number;

  /**
   * Create an instance of DocsCodificationFieldsModel.
   *
   * @param docsCodificationFields The docs codification fields settings.
   */
  constructor(docsCodificationFields: DocsCodificationFieldsInterface) {
    this.id = docsCodificationFields.id;
    this.name = docsCodificationFields.name;
    this.type = docsCodificationFields.type;
    this.typeMetadatas = docsCodificationFields.typeMetadatas;
    this.codificationId = docsCodificationFields.codificationId;
  }
}
